export const urlParams = (params) => {
  if(!params) return ''

  const validParams = {}
  for(const key in params) {
    if(Boolean(params[key])) validParams[key] = params[key]
  }

  return '?' + new URLSearchParams(validParams)
}